// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#phone-confirm {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#phone-confirm-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  width: 100%;
}
#phone-confirm-header h4 {
  margin: auto;
  color: var(--color-primary);
}

#phone-confirm-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 10px;
  height: 100%;
}

a {
  text-decoration: none;
}

#phone-confirm-form-container > div, #phone-confirm-form > label {
  margin: 20px;
}

#confirm-code-btn {
  margin: 20px 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/register/phone-confirm/phone-confirm.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACJ;AAAI;EACI,YAAA;EACA,2BAAA;AAER;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,YAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":["#phone-confirm {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n}\r\n\r\n#phone-confirm-header {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    background-color: white;\r\n    width: 100%;\r\n    h4 {\r\n        margin: auto;\r\n        color: var(--color-primary);\r\n    }\r\n}\r\n\r\n#phone-confirm-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    row-gap: 10px;\r\n    height: 100%;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n}\r\n\r\n#phone-confirm-form-container > div, #phone-confirm-form > label {\r\n    margin: 20px;\r\n}\r\n\r\n#confirm-code-btn {\r\n    margin: 20px 30px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
